//#region src/time/timestamp.ts
const MICROSECONDS_PER_SECOND = 1e6;
const MICROSECONDS_PER_MILLISECOND = 1e3;
/**
* Default time source.
*
* Prefers `performance.timeOrigin + performance.now()`, which is monotonic and
* sub-millisecond; `Date.now()` is both coarser and subject to NTP steps that
* would show up as phantom clock drift. Falls back to `Date.now()` where the
* performance timeline is unavailable.
*
* Both APIs are ECMAScript/W3C standards present in browsers and Node alike, so
* this stays platform-free.
*/
const systemTimeSource = { now() {
	const perf = globalThis.performance;
	if (perf?.now !== void 0 && typeof perf.timeOrigin === "number") return Math.round((perf.timeOrigin + perf.now()) * MICROSECONDS_PER_MILLISECOND);
	return Date.now() * MICROSECONDS_PER_MILLISECOND;
} };
/** Time source driven by hand. Used by replay and by tests. */
var ManualTimeSource = class {
	#current;
	constructor(start = 0) {
		this.#current = start;
	}
	now() {
		return this.#current;
	}
	set(value) {
		this.#current = value;
	}
	advance(microseconds) {
		this.#current += microseconds;
		return this.#current;
	}
};
//#endregion
export { systemTimeSource as i, MICROSECONDS_PER_SECOND as n, ManualTimeSource as r, MICROSECONDS_PER_MILLISECOND as t };

//# sourceMappingURL=timestamp-CRYLj3P9.js.map